import { Inject } from '@odinjs/odin';
import { PaginatorAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnDynamicContentRender, OnMount } from '@philips-internal/oswald-ui-core/lib/client';
import { RenderEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { MessageService } from '@philips-internal/oswald-ui-core/lib/services';
import { applicationContext } from '@philips-internal/oswald-ui-foundation';

import { ReactComponent as OpenSVG } from '../../../resources/assets/commons/open.svg';
import { FragmentNames, VersionListAliases } from '../../codegen';
import { VersionRoutesApplication } from '../../constants';
import { Version } from '../../interfaces/version';
import { Utils } from '../../utils';
import BaseController from '../BaseController';

@Controller({ fragment: FragmentNames.VERSION_LIST })
export default class VersionListController extends BaseController {

  @Inject(VersionListAliases.PAGINATOR_VERSION)
  paginatorVersion!: PaginatorAPI;

  @OnMount({ target: VersionListAliases.LAYOUT_VERSION })
  onMount(): void {
    const event = new CustomEvent('updateModulesRoute', { detail: { moduleId: 'version' } });
    dispatchEvent(event);
  }

  @OnMount(VersionListAliases.TABLE_VERSION)
  onMountDataTableVersion(): void {
    Utils.getFirstPagePaginator(this.paginatorVersion);
  }

  @OnDynamicContentRender(VersionListAliases.TABLE_VERSION)
  onRenderTableVersion(event: RenderEvent): void {
    if (event.entry === 'versionExclusive' || event.entry === 'actions') {
      event.render((data: Version) => {
        if (event.entry === 'versionExclusive') {
          return Utils.renderTableText(MessageService.translate(data.versionExclusive === 'S' ? 'text.yes' : 'text.no'));
        }

        return Utils.renderActionButtons([
          { title: 'open.action', icon: OpenSVG, onClick: () => this.openVersion(data) },
        ]);
      });
    }
  }

  openVersion(version: Version): void {
    applicationContext.redirect(VersionRoutesApplication.VERSION_FILE_LIST, { versionId: version.id });
  }
}
